import { ADDTOCART } from "../allProduct/actionIdentifier";
import { MULTIPLEADD, REMOVEITEM } from "./actionIdentifier";

//define InitialState
const initialState = [];

//reducer functiion
const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADDTOCART:
      let addedState = [];
      if (state.length === 0) {
        addedState.push({ ...action.payload.product, addedItem: 1 });
      } else {
        addedState = state.map((product) => {
          return {
            ...product,
          };
        });
        addedState.push({ ...action.payload.product, addedItem: 1 });
      }
      return addedState;
    case MULTIPLEADD:
      const multiAddedState = state.map((singleProduct) => {
        if (action.payload.id === singleProduct.productId) {
          return {
            ...singleProduct,
            addedItem: singleProduct.addedItem + 1,
          };
        } else {
          return {
            ...singleProduct,
          };
        }
      });
      return multiAddedState;
    case REMOVEITEM:
      const removedState = state.map((singleProduct) => {
        if (singleProduct.productId === action.payload.id) {
          return {
            ...singleProduct,
            addedItem: singleProduct.addedItem - 1,
          };
        } else {
          return {
            ...singleProduct,
          };
        }
      });
      return removedState.filter((singleProduct) => singleProduct.addedItem !== 0);
    default:
      return state;
  }
};

export default cartReducer;
